import React, { useRef, useLayoutEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PlaceInfoCard = ({
  selectedPlace,
  getPlacePhotoUrl,
  onClose,
  position,
  show = true,
}) => {
  const cardRef = useRef(null);

  // 動態取得卡片中心點，定位顯示按鈕
  useLayoutEffect(() => {
    if (cardRef.current) {
      // const rect = cardRef.current.getBoundingClientRect();
      // TODO: 可能的後續處理邏輯
    }
  }, [selectedPlace]);

  const photoUrl = selectedPlace && getPlacePhotoUrl(selectedPlace, 400);
  const rating = selectedPlace?.rating;
  const opening = selectedPlace?.opening_hours;
  const isOpen =
    opening && typeof opening.open_now === "boolean" ? opening.open_now : null;

  return (
    <AnimatePresence mode="wait">
      {show && selectedPlace && (
        <motion.div
          key={
            selectedPlace.place_id || selectedPlace.name || "place-info-card"
          }
          ref={cardRef}
          initial={{ opacity: 0, x: -20, scale: 0.95 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, x: 20, scale: 0.95 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="absolute z-20 bg-[#181c23] rounded-xl shadow-lg border border-[#23272f] max-w-[250px] min-w-[100px] w-[70vw] overflow-visible font-sans text-gray-100 backdrop-blur-sm transition-all duration-300 ease-in-out"
          style={
            position && !isNaN(position.x) && !isNaN(position.y)
              ? {
                  top: "2.5rem",
                  left: position.x + 8,
                  transform: "scale(0.7)",
                }
              : {
                  left: 8,
                  top: "0.5rem",
                  transform: "scale(0.7)",
                }
          }
        >
          {/* X 按鈕（右上角，貼齊卡片邊緣） */}
          <button
            className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full bg-amber-600 text-white text-lg font-bold shadow hover:bg-amber-700 transition focus:outline-none focus:ring-2 focus:ring-amber-400 z-20"
            onClick={onClose}
            aria-label="關閉景點資訊"
            type="button"
            style={{ zIndex: 20 }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="5" y1="5" x2="15" y2="15" />
              <line x1="15" y1="5" x2="5" y2="15" />
            </svg>
          </button>
          {/* 圖片區塊 */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, delay: 0.05 }}
          >
            {photoUrl ? (
              <div className="w-full overflow-hidden rounded-t-xl">
                <motion.img
                  src={photoUrl}
                  alt={selectedPlace.name}
                  className="w-full h-52 object-cover object-center rounded-t-xl"
                  initial={{ scale: 1.1 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                />
              </div>
            ) : (
              <div className="w-full h-52 bg-[#23272f] flex items-center justify-center text-4xl text-amber-900 rounded-t-xl">
                <motion.span
                  role="img"
                  aria-label="no-photo"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.2, delay: 0.05 }}
                >
                  📷
                </motion.span>
              </div>
            )}
          </motion.div>
          <motion.div
            className="p-3 sm:p-4 flex-1 flex flex-col justify-between"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, delay: 0.1 }}
          >
            <div>
              <div className="text-xl font-bold text-amber-200 mb-2 tracking-tight">
                {selectedPlace.name}
              </div>
              <div className="flex items-center gap-2 text-gray-300 text-base mb-1">
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#fbbf24"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M17.657 16.657L13.414 20.9a2 2 0 0 1-2.828 0l-4.243-4.243a2 2 0 0 1 0-2.828l4.243-4.243a2 2 0 0 1 2.828 0l4.243 4.243a2 2 0 0 1 0 2.828z" />
                  <path d="M15 11V7a3 3 0 0 0-6 0v4" />
                </svg>
                <span>
                  {selectedPlace.vicinity || selectedPlace.formatted_address}
                </span>
              </div>
              {/* 評分、開放狀態 */}
              <div className="flex items-center gap-3 mb-2">
                {rating && (
                  <span className="font-bold text-amber-400 text-base flex items-center gap-1">
                    <span className="text-lg">★</span> {rating}
                  </span>
                )}
                {isOpen !== null && (
                  <span
                    className={`ml-2 text-sm font-semibold ${
                      isOpen ? "text-green-400" : "text-red-400"
                    }`}
                  >
                    {isOpen ? "營業中" : "已打烊"}
                  </span>
                )}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PlaceInfoCard;
